import { Button, ModalHead, ScrollBar, toastError, toastSuccess } from 'admination-react'
import { useEffect, useRef, useState } from 'react'
import { useApp } from '@/core/state/appStore'
import { currentVariant } from '@/core/data/session'
import { createMassnahme } from '@/core/data/massnahmen'
import { FormRenderer } from '@/core/components/form/FormRenderer'
import { initialFormValues, updateFormField, type FormValues } from '@/core/components/form/formModel'
import { descriptionFor } from '@/variants'
import { getAt } from '@/core/lib/path'
import { Icon } from 'admination-react'
import { friendlyErrorMessage } from '@/core/lib/dbError'
import {
  checkMassnahmeCreate,
  MASSNAHME_CREATE_HINTS,
  MASSNAHME_CREATE_REQUIRED_FIELDS,
  MASSNAHME_SELECT_REQUIRED_FIELDS,
} from './massnahmeForm'

const ANSPRECHPARTNER_PATH = 'Ansprechpartner.Ansprechpartner'

export function CreateMassnahmeModal() {
  const { dispatch, reloadMassnahmen, identity } = useApp()
  const scrollerRef = useRef<HTMLElement>(null)
  const massnahmeTemplate = descriptionFor(currentVariant()).massnahmeForm
  const creationTemplate = {
    ...massnahmeTemplate,
    sections: Object.fromEntries(Object.entries(massnahmeTemplate.sections).filter(([section]) => section !== 'Ansprechpartner' && section !== 'Anwesenheit' && section !== 'Aktivierung')),
  }
  const [values, setValues] = useState<FormValues>(() => initialFormValues(creationTemplate))
  const organisationId = identity?.organisationId
  const [busy, setBusy] = useState(false)

  useEffect(() => {
    if (!identity) return
    setValues((previous) => getAt(previous, ANSPRECHPARTNER_PATH) ? previous
      : updateFormField(previous, ANSPRECHPARTNER_PATH, identity.userId))
  }, [identity])

  const close = () => dispatch({ type: 'CLOSE' })

  const setField = (path: string, v: unknown) => {
    setValues((prev) => updateFormField(prev, path, v))
  }

  const check = checkMassnahmeCreate(values)
  const ready = check.fields !== null

  const submit = async () => {
    if (!check.fields || !organisationId || busy) return
    setBusy(true)
    try {
      await createMassnahme(organisationId, check.fields)
      reloadMassnahmen()
      toastSuccess("Maßnahme angelegt.")
      close()
    } catch (e) {
      console.error("Maßnahme anlegen fehlgeschlagen:", e)
      toastError(friendlyErrorMessage(e, "Anlegen fehlgeschlagen."))
    } finally {
      setBusy(false)
    }
  }

  return (
    <>
      <ModalHead titleIcon="i-massnahme" title="Neue Maßnahme" actions={<>
          <div className="pill-cluster">
            <div className="pill">
              <Button
                type="button"
                primaryAction
                loading={busy}
                disabled={!ready || busy}
                onClick={() => void submit()}
              >
                <Icon name="i-check" />
                Anlegen</Button>
            </div>

          </div>
        </>} onClose={close} closeLabel="Schließen" />
      <main className="form" data-scroll-host ref={scrollerRef}>
        <FormRenderer
            definition={creationTemplate}
            values={values}
            onChange={setField}
            errors={check.errors}
            field={(field) => ({
              required:
                MASSNAHME_CREATE_REQUIRED_FIELDS?.has(field.id) || (field.control === 'select' && MASSNAHME_SELECT_REQUIRED_FIELDS?.has(field.id)),
              missing: MASSNAHME_CREATE_REQUIRED_FIELDS?.has(field.id) ? 'mark' : undefined,
              hint: check.errors.has(field.id) ? MASSNAHME_CREATE_HINTS.get(field.id) : undefined,
            })}
          />
      </main>
      <ScrollBar scrollerRef={scrollerRef} />
    </>
  )
}
